module.exports = __webpack_public_path__ + "static/SteveHanDevResume-52cb4ed9214a166dd4b71eda6ddac5f1.pdf";